import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Question} from '../models/underwriter.model';

@Injectable({
  providedIn: 'root'
})
export class QuestionPasserService {
  private subject = new Subject<Question>();

  passQuestion(question: Question): void {
    this.subject.next(question);
  }

  updateComponent(): Observable<Question> {
    return this.subject.asObservable();
  }
}
